import React from 'react';
import PlansCompareCards from './PlansCompareCards';
import { useLanguage } from '../../contexts/LanguageContext';

const IconClose = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

/**
 * Thin overlay wrapper around PlansCompareCards — used only by the
 * post-registration onboarding flow (PostRegisterPlansModal). Every
 * in-app "upgrade" trigger (openUpgrade / UpgradeModal) now redirects to
 * the full-page /planes (PlansPage.js) instead of this modal, so the two
 * never need to visually match anymore — but they still share the same
 * cards/checkout code via PlansCompareCards.
 */
const PlansCompareModal = ({
  onClose,
  currentPlanId,
  title,
  subtitle,
}) => {
  const { t } = useLanguage();
  const resolvedTitle = title || t('plansCompareModal.title', 'Elige cómo quieres empezar');
  const resolvedSubtitle = subtitle || t('plansCompareModal.subtitle', 'Ya creaste tu perfil. Ahora elige el plan que mejor se ajuste a ti.');
  return (
    <div className="prp-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="prp-modal">
        <button className="prp-close" onClick={onClose} aria-label={t('plansCompareModal.close', 'Cerrar')}><IconClose /></button>
        <PlansCompareCards currentPlanId={currentPlanId} title={resolvedTitle} subtitle={resolvedSubtitle} onClose={onClose} />
      </div>
      <style>{OVERLAY_CSS}</style>
    </div>
  );
};

const OVERLAY_CSS = `
.prp-overlay{position:fixed;inset:0;z-index:400;background:rgba(0,0,0,.5);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:20px;animation:prpFade .2s ease}
@keyframes prpFade{from{opacity:0}to{opacity:1}}
@keyframes prpSlide{from{opacity:0;transform:translateY(16px) scale(.97)}to{opacity:1;transform:translateY(0) scale(1)}}
.prp-modal{position:relative;background:#fff;border-radius:16px;max-width:920px;width:100%;max-height:90vh;overflow-y:auto;padding:40px 40px 36px;box-shadow:0 30px 80px rgba(0,0,0,.35);font-family:'Inter',system-ui,sans-serif;animation:prpSlide .25s cubic-bezier(.16,1,.3,1)}
.prp-close{position:absolute;top:20px;right:20px;width:32px;height:32px;border-radius:8px;background:#f5f5f5;border:none;color:#4a4a4a;cursor:pointer;display:flex;align-items:center;justify-content:center}
.prp-close:hover{background:#ececec;color:#000}

@media(max-width:760px){
  .prp-modal{padding:28px 22px 24px;border-radius:14px}
}
`;

export default PlansCompareModal;
